import { render, staticRenderFns } from "./AvatarsGroup.vue?vue&type=template&id=a423720a&"
import script from "./AvatarsGroup.vue?vue&type=script&lang=js&"
export * from "./AvatarsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports